import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  HeaderText,
  Stack,
  Touchable,
} from '../../../../ui';
import Image from '../../../../shared/Image';

const LOGO = require('../../../../../../images/styleseat-logo-white.svg');

export type UserInstructionStepProps = {
  loading: boolean;
  message?: string;
  footer?: React.ReactNode;
  /** Any additional components to display immediately above the instructional message */
  children?: React.ReactNode;
  onClickContinue?: (e?: any) => void;
};

const UserInstructionStep: React.FC<UserInstructionStepProps> = ({
  loading,
  children,
  footer,
  message = null,
  onClickContinue = () => {},
}) => (
  <Touchable
    onClick={onClickContinue}
    disabled={!onClickContinue}
    testID="user-instruction-step-component"
  >
    <Box flex={1} color={colors.blackInBlack} padding={24}>
      <React.Fragment>
        <Box flex={22} />
        <Stack
          flex={37}
          space={40}
          alignItems="center"
          justifyContent="space-between"
        >
          {children || (
            <Box minHeight={99} maxHeight={99}>
              <Image source={LOGO} style={{ width: 183, height: 99 }} />
            </Box>
          )}
          {message && (
            <Box maxWidth={260}>
              <HeaderText
                whiteSpace="pre-line"
                textAlign="center"
                color={colors.whiteWash}
              >
                {message}
              </HeaderText>
            </Box>
          )}
          {footer || (
            <Stack paddingTop={8} alignItems="center">
              <HeaderText
                level={3}
                textAlign="center"
                color={loading ? colors.ash : colors.whiteWash}
              >
                Tap anywhere to continue
              </HeaderText>
              <HeaderText
                level={3}
                textAlign="center"
                color={loading ? colors.ash : colors.whiteWash}
              >
                Tap to Pay on StyleSeat
              </HeaderText>
            </Stack>
          )}
        </Stack>
        <Box flex={41} />
      </React.Fragment>
    </Box>
  </Touchable>
);

export default UserInstructionStep;
